// SearchPlant.js
import React, { useEffect, useState, useMemo, useCallback } from "react";
import DataTable from "react-data-table-component";
import AxiosInstance from '../Axios/AxiosInstance';
import Modal from 'react-bootstrap/Modal';
import "../../Assets/Styles/robot.css";
import "../../Assets/Styles/Form.css";
import * as FaIcons from "react-icons/fa";

const customStyles = {
    table: { style: { border: "none", fontSize: "100%" } },
    header: { style: { backgroundColor: "transparent" } },
    rows: { style: { backgroundColor: "transparent" } },
    headRow: { style: { backgroundColor: "transparent", fontSize: "110%" } },
    pagination: { style: { backgroundColor: "transparent", fontWeight: "600" } },
    headCells: { style: { borderBottom: "none", fontWeight: "700", fontSize: "110%" } },
};

export const SearchPlant = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [plantData, setPlantData] = useState([]);  // always holds the FULL unfiltered list
    const [plantID, setPlantID] = useState(null);
    const [plantName, setPlantName] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchError, setFetchError] = useState(null);
    const [deleteError, setDeleteError] = useState(null);

    // -----------------------------------------------------------------------
    // BUG FIX 1: The component was keeping two separate lists � plantData and
    // plantList � and switching between them inconsistently.  After a delete
    // + refetch, plantList got reset to the full list but searchTerm was still
    // set, so the displayed rows and the search box were out of sync.
    //
    // Fix: keep ONE source of truth (plantData = full API result) and derive
    // the displayed rows via useMemo every render.  No plantList state needed.
    // -----------------------------------------------------------------------
    const filteredData = useMemo(() => {
        if (!searchTerm.trim()) return plantData;
        const lower = searchTerm.toLowerCase();
        return plantData.filter((item) =>
            Object.values(item).some(
                (v) => typeof v === "string" && v.toLowerCase().includes(lower)
            )
        );
    }, [plantData, searchTerm]); // recalculates whenever data OR search term changes

    // -----------------------------------------------------------------------
    // BUG FIX 2: fetchPlantData was not guarding against a non-array response.
    // If the API returned an error object instead of an array, setPlantData()
    // stored that object, DataTable received it and the list went blank with no
    // visible error.
    // -----------------------------------------------------------------------
    const fetchPlantData = useCallback(async () => {

        const company_id = sessionStorage.getItem("user_companyid");
        const plant_id = sessionStorage.getItem("user_plantid");
        const user_id = sessionStorage.getItem("user_id");
        setIsLoading(true);
        setFetchError(null);
        //alert("fdhfghfdhgf");
        try {
            const response = await AxiosInstance.get(
                `/Plant/GetPlant?pid=${company_id}&uid=${user_id}&pn=SearchPlant&sn=SearchAllPlant`
            );

            // Log the raw response so we can see exactly what the API returns
            console.log("GetPlant HTTP status :", response.status);
            console.log("GetPlant response.data:", response.data);
            console.log("GetPlant data type    :", typeof response.data, Array.isArray(response.data) ? "(array)" : "");

            let plantArray = null;

            if (Array.isArray(response.data)) {
                // Standard case: API returned a plain JSON array  [ {...}, {...} ]
                plantArray = response.data;

            } else if (response.data && Array.isArray(response.data.$values)) {
                // .NET ReferenceHandler.Preserve wraps arrays as:
                // { "$id": "1", "$values": [ {...}, {...} ] }
                console.warn("Response wrapped in $values � check if ReferenceHandler.Preserve is set in Program.cs");
                plantArray = response.data.$values;

            } else if (response.data && Array.isArray(response.data.data)) {
                // Some APIs wrap results as: { "data": [...], "message": "..." }
                console.warn("Response wrapped in .data property");
                plantArray = response.data.data;

            } else {
                // Unknown shape � log it clearly so it's easy to diagnose
                console.error("GetPlant returned an unrecognised shape. Full response.data:", JSON.stringify(response.data, null, 2));
                setFetchError(
                    `Unexpected response format (type: ${typeof response.data}). ` +
                    `Check browser console for the full response.`
                );
                setPlantData([]);
            }

            if (plantArray !== null) {
                setPlantData(plantArray);
            }
        } catch (error) {
            console.error("Fetch error:", error);
            setFetchError("Failed to load farm list. Please refresh.");
            setPlantData([]);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPlantData();
    }, [fetchPlantData]);

    const edit_plant = (plantID) => {
        sessionStorage.removeItem("editpid");
        sessionStorage.setItem("editpid", plantID);
        window.location.href = "#/edit-plant?pid=" + plantID;
    };

    // FIX: accepts full row so lat, lon, area and boundary travel with plantID
    const scanFarm = (plantID, plant_lat, plant_lon, plant_area, plant_boundry, crop_name_en) => {
        sessionStorage.removeItem("scanfarmpid");
        sessionStorage.removeItem("scanfarmlat");
        sessionStorage.removeItem("scanfarmlon");
        sessionStorage.removeItem("scanfarmarea");
        sessionStorage.removeItem("scanfarmboundry");
        sessionStorage.removeItem("scanfarmcrop");


        sessionStorage.setItem("scanfarmpid", plantID);
        if (plant_lat) sessionStorage.setItem("scanfarmlat", String(plant_lat));
        if (plant_lon) sessionStorage.setItem("scanfarmlon", String(plant_lon));
        if (plant_area) sessionStorage.setItem("scanfarmarea", String(plant_area));
        if (plant_boundry) sessionStorage.setItem("scanfarmboundry", String(plant_boundry));
        if (crop_name_en) sessionStorage.setItem("scanfarmcrop", String(crop_name_en));

        window.location.href = "#/agri-dashboard?pid=" + plantID;
    };

    const openDeleteModal = (plant_id, plant_name) => {
        setPlantID(plant_id);
        setPlantName(plant_name);
        setDeleteError(null);
        setShowModal(true);
    };

    const closeDeleteModal = () => {
        setShowModal(false);
        setPlantID(null);
        setPlantName("");
        setDeleteError(null);
    };

    // -----------------------------------------------------------------------
    // BUG FIX 3: deleteRecord was not awaiting fetchPlantData(), so the list
    // refresh was fire-and-forget.  If the refetch happened to lose a React
    // batching race the table would stay stale until the next render cycle.
    //
    // BUG FIX 4: The modal was closed BEFORE confirming the refetch succeeded.
    // If fetchPlantData threw, the modal was already gone so the user had no
    // way to retry and the list silently stayed stale.
    //
    // Fix: await the refetch first, then close the modal only on success.
    // -----------------------------------------------------------------------
    const deleteRecord = async () => {
        const user_id = sessionStorage.getItem("user_id");
        setDeleteError(null);
        try {
            const response = await AxiosInstance.delete(
                `/Plant/DeletePlant?pid=${plantID}&uid=${user_id}&pn=DeletePlant`
            );
            if (response.data) {
                await fetchPlantData(); // await so list is fresh before modal closes
                closeDeleteModal();     // only close AFTER list is updated
            }
        } catch (error) {
            console.error("Delete error:", error);
            setDeleteError("Delete failed. Please try again.");
        }
    };

    const handleSearch = (event) => {
        // No manual filtering needed � filteredData useMemo handles it reactively.
        setSearchTerm(event.target.value);
    };

    // BUG FIX 5: columns was re-created on every render, causing DataTable to
    // re-render even when data had not changed. useMemo prevents this.
    const columns = useMemo(() => [
        {
            name: "ID",
            selector: (row) => (
                <a className="alink" onClick={() => edit_plant(row.plant_id)}>
                    {row.plant_id}
                </a>
            ),
            sortable: true,
        },
        { name: "Company", selector: (row) => row.company_name, sortable: true }, 
        { name: "Farm", selector: (row) => row.plant_name, sortable: true },
        { name: "Crop", selector: (row) => row.crop_name_en, sortable: true },
        { name: "Contact Person", selector: (row) => row.contact_person_name, sortable: true },
        { name: "Email ID", selector: (row) => row.contact_email_id, sortable: true },
        { name: "Contact Number", selector: (row) => row.contact_number, sortable: true },
        { name: "Address", selector: (row) => row.plant_address, sortable: true },
        { name: "Lat", selector: (row) => row.plant_lat, sortable: true },
        { name: "Lon", selector: (row) => row.plant_lon, sortable: true },
        { name: "Date", selector: (row) => row.plant_added_date, sortable: true },
        {
            name: "Scan Farm",
            selector: (row) => (
                <a className="alink" onClick={() => scanFarm(row.plant_id, row.plant_lat, row.plant_lon, row.plant_area, row.plant_boundry, row.crop_name_en)}>Scan Farm</a>
            ),
            sortable: false,
        },
        {
            name: "Delete",
            selector: (row) => (
                <a className="alink" onClick={() => openDeleteModal(row.plant_id, row.plant_name)}>
                    Delete
                </a>
            ),
            sortable: false,
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ], []); // functions are stable; no deps needed

    return (
        <div className="page-container">
            <div className="search-container">
                <h2 className="form-title">
                    <FaIcons.FaSearch /> Search Farm
                </h2>
                <div className="row">
                    <div className="col-1"></div>
                    <div className="col-12">
                        <a className="btndelete" href="#/add-plant">Add New Farm</a>
                    </div>
                </div>

                {/* BUG FIX 6: no user feedback on load failure � now shown */}
                {fetchError && (
                    <div className="alert alert-danger" style={{ margin: "1% 2%" }}>
                        {fetchError}
                    </div>
                )}

                <div>
                    <div style={{
                        border: "1px solid #c0c0c0",
                        borderRadius: "5px",
                        margin: "2%",
                        backgroundColor: "#fff",
                    }}>
                        <div className="container dvscroll">
                            <div className="row dvscroll">
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        placeholder="Search Results"
                                        style={{
                                            width: "20%",
                                            height: "30px",
                                            margin: "10px",
                                            float: "right",
                                            border: "none",
                                            padding: "1.5%",
                                            borderRadius: "5px",
                                        }}
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                    <DataTable
                                        className="table table-sm table-hover"
                                        pagination
                                        columns={columns}
                                        data={filteredData}
                                        progressPending={isLoading}
                                        highlightOnHover
                                        customStyles={customStyles}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={showModal}
                onHide={closeDeleteModal}
                size="lg"
                aria-labelledby="delete-modal-title"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="delete-modal-title">Delete Farm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>
                        Are you sure you want to delete Plant ID:{" "}
                        <strong>{plantID}</strong> ({plantName})?
                    </span>
                    {/* BUG FIX 7: delete errors are now shown inside the modal
                        so the user knows the delete failed and can retry */}
                    {deleteError && (
                        <div className="alert alert-danger" style={{ marginTop: "10px" }}>
                            {deleteError}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <a className="btndelete" onClick={deleteRecord}>Delete</a>
                    <a className="btncancel" onClick={closeDeleteModal}>Cancel</a>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SearchPlant;